export function sortProvinceOptions(provinces = []) {
  return [...provinces].sort((firstOption, secondOption) =>
    (firstOption?.label || firstOption?.name || '').localeCompare(
      secondOption?.label || secondOption?.name || '',
      'id'
    )
  );
}
